import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ew",
  "use": "icon-ew-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ew\">\n<g id=\"icon-ew_Menu/ew\">\n<path id=\"icon-ew_file-word\" d=\"M3.5 2.00006V14.0001H6.5V15.0001H3.49534C3.02005 15.0001 2.5 14.6628 2.5 14.0781V1.92197C2.5 1.33733 3.02005 1.00006 3.49534 1.00006L8.8658 1C9.13433 1 9.39158 1.108 9.57964 1.29969L13.2138 5.004C13.3972 5.19096 13.4999 5.44241 13.4999 5.70431V8H12.4999V6.01275H8.5V2L3.5 2.00006ZM9.5 2.64645V5.01275H11.8215L9.5 2.64645Z\" fill=\"#282C33\" />\n<path id=\"icon-ew_file-word_2\" d=\"M9 14L13.5 14V15L9 15C8.44771 15 8 14.5523 8 14V10.5C8 9.94771 8.44772 9.5 9 9.5H13.5V10.5L9 10.5V11.75L13.5 11.75V12.75L9 12.75V14Z\" fill=\"#282C33\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ew.svg
// module id = FfkS
// module chunks = 140